export default __webpack_public_path__ + "2adf4baa74d6e779125db1f98a86612b.png";